export default __webpack_public_path__ + "static/O0269-a56bf630e192303100b3b1b2b95ebceb.png";